import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import Paragraph from '@tiptap/extension-paragraph';

export const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return {
      style: {
        default: null,
        renderHTML: attributes => {
          if (attributes.style) {
            return { style: attributes.style };
          }
        }
      }
    };
  }
});

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      style: {
        default: null,
        renderHTML: attributes => {
          if (attributes.style) {
            return { style: attributes.style };
          }
        }
      },
      valign: {
        default: null,
        renderHTML: attributes => {
          if (attributes.valign) {
            return { valign: attributes.valign };
          }
        }
      }
    };
  }
});

export const CustomTable = Table.extend({
  addAttributes() {
    return {
      style: {
        default: null,
        renderHTML: attributes => {
          if (attributes.style) {
            return { style: attributes.style };
          }
        }
      },
      id: {
        default: null,
        renderHTML: attributes => {
          if (attributes.id) {
            return { id: attributes.id };
          }
        }
      }
    };
  }
});
